import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { mapValues, noop } from 'lodash';
import { LazyComponent, StatusToast } from '@fiverr-private/orca';
import { logger } from '@fiverr-private/obs';
import { translate } from '@fiverr-private/i18n-react';
import { DEFAULT_STYLE, GROUPS } from './constants';
import PickerLoader from './PickerLoader';

const Picker = ({ onEmojiClick = noop, style = DEFAULT_STYLE }) => {
    const componentProps = useMemo(() => {
        const groupNames = mapValues(GROUPS, (_, group) =>
            translate(`send_message.emoji_picker.categories.${group}`)
        );

        return {
            onEmojiClick,
            pickerStyle: style,
            groupNames,
            groupVisibility: GROUPS,
            native: true
        };
    }, [onEmojiClick, style]);

    const lazyImport = () => import(/* webpackChunkName: 'EmojiPickerReact' */'emoji-picker-react');

    const onError = (error) => {
        StatusToast.raise({
            message: translate('send_message.validation.something_wrong'),
            theme: StatusToast.THEMES.ERROR
        });

        logger.error(error, {
            details: 'Failed to load emoji picker'
        });
    };

    return (
        <LazyComponent lazyImport={lazyImport}
            shouldImport
            componentProps={componentProps}
            placeholder={<PickerLoader style={style}/>}
            onError={onError}/>
    );
};

Picker.propTypes = {
    onEmojiClick: PropTypes.func,
    style: PropTypes.shape({
        width: PropTypes.number,
        height: PropTypes.number
    })
};

export default Picker;
